import { ToggleSwitch } from '@omnipresentgroup/design-system';
import { useUpdateCompanyMutation } from '@omnipresentgroup/domains';
import type { Company } from '@omnipresentgroup/types';

export const MFADetails = ({
  companyId,
  enforceMFA,
  canEdit,
}: {
  companyId: string;
  enforceMFA: NonNullable<Company['settings']>['enforceMFA'];
  canEdit?: boolean;
}) => {
  const { mutate: updateCompany } = useUpdateCompanyMutation({ companyId });

  return (
    <ToggleSwitch
      id="mfa-toggle-switch"
      name="mfa-toggle-switch"
      checked={Boolean(enforceMFA)}
      readOnly={!canEdit}
      onCheckedChange={() => {
        updateCompany({ settings: { enforceMFA: !enforceMFA } });
      }}
    />
  );
};
